// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-enter-active,\n.list-leave-active {\n  transition: transform 1s;\n}\n.list-enter-from,\n.list-leave-to {\n  opacity: 0;\n}\ntest, test:hover {\n  text-decoration: none !important;\n  cursor: hand;\n}", ""]);
// Exports
module.exports = exports;
